import { format } from 'date-fns';
import { defaultDateFormat } from './constants';
import getLocale from './getLocale';
import parseDate from './parseDate';

const formatDate = (date, dateFormat = defaultDateFormat) => {
  const parsedDateTime = parseDate(date);

  return parsedDateTime ? format(parsedDateTime, dateFormat, { locale: getLocale() }) : null;
};

export default formatDate;
